<div class="bg-white shadow-sm p-3 rounded mb-3">
  <div class="d-flex justify-content-between">
    <h6 class="text-truncate" style="max-width: 70%">
      {{ workshop.title }}
    </h6>
  </div>
  <div class="mt-3">
    <ng-icon name="lucideUser" class="me-2 text-secondary"></ng-icon>
    <span class="align-self-center"
      >{{ "trainingHist.labels.teacher" | translate }}:
      {{ workshop.teacherFullName }}</span
    >
  </div>
  <div class="mt-2">
    <ng-icon name="lucideCalendar" class="me-2 text-secondary"></ng-icon>
    <span class="align-self-center"
      >{{ "trainingHist.labels.eventDate" | translate }}:
      {{ concatTimes(workshop.holdingTimes) }} ({{
        formatMinutesToTime(workshop.duration)
      }}
      ساعت)</span
    >
  </div>
  <div class="mt-2">
    <ng-icon name="lucideLayers" class="me-2 text-secondary"></ng-icon>
    <span class="align-self-center"
      >{{ "trainingHist.labels.method" | translate }}:
      {{ workshop.holdingTypeTitle }}</span
    >
  </div>
  <div class="mt-2" *ngIf="workshop.locationTitle?.length">
    <ng-icon name="lucideMapPin" class="me-2 text-secondary"></ng-icon>
    <span class="align-self-center"
      >{{ "trainingHist.labels.location" | translate }}:
      {{ workshop.locationTitle }}</span
    >
  </div>
  <div class="mt-2">
    <ng-container [ngSwitch]="workshop.isPresent">
      <span
        *ngSwitchCase="true"
        class="badge bg-success rounded-pill text-light"
      >
        {{ "trainingHist.labels.present" | translate }}
      </span>
      <span
        *ngSwitchCase="false"
        class="badge bg-danger rounded-pill text-light"
      >
        {{ "trainingHist.labels.absent" | translate }}
      </span>
    </ng-container>
  </div>
  <div class="mt-3">
    <dx-popup
      title="دریافت فایل‌های کارگاه"
      [(visible)]="showContentsDialog"
      [width]="500"
      [height]="'auto'"
      [showTitle]="true"
      [dragEnabled]="false"
      [hideOnOutsideClick]="true"
      [showCloseButton]="true"
      shadingColor="rgba(0, 0, 0, 0.05)"
    >
      <div *ngIf="selectedContents?.length">
        <ul class="list-unstyled mb-0">
          <li *ngFor="let contentItem of selectedContents" class="content-item">
            <ng-icon name="lucidePaperclip" class="me-2 text-success"></ng-icon>
            <a
              href="#"
              (click)="downloadContent(contentItem); $event.preventDefault()"
              class="text-success"
            >
              {{ contentItem.file_name }}
            </a>
          </li>
        </ul>
      </div>
    </dx-popup>
  </div>
  <div class="mt-3">
    <button
      class="btn btn-outline-success my-1"
      (click)="openContentsDialog(workshop)"
      [disabled]="workshop.contents.length === 0"
    >
      دریافت فایل‌ها
    </button>
    <span class="px-1"></span>
    <a
      class="text-decoration-none text-success"
      *ngIf="workshop.surveyLink"
      [href]="workshop.surveyLink"
      target="_blank"
      rel="noopener noreferrer"
      (click)="markContentsDownloadAsAllowed(workshop)"
    >
      نظرسنجی
    </a>
  </div>
</div>
